import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { WorkflowIcon } from 'lucide-react'

import { CardMetadata } from '@/components/block/common/card-metadata'
import { Page } from '@/components/layout/page'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

import { mokaApi } from '@/features/moka'
import { MokaConnectDialog } from '@/features/moka/components/moka-connect-dialog'
import { outletMasterApi } from '@/features/outlet/outlet-api'

import { useAuth } from '@/lib/auth'

export const Route = createFileRoute('/_app/outlet/')({
  component: RouteComponent,
})

function RouteComponent() {
  const outlet = useOutlet()

  return (
    <Page>
      <Page.Breadcrumbs />
      <Page.TwoColumn>
        <Page.Column>
          <GeneralInfo />
        </Page.Column>
        <Page.Column>{outlet.type === 'store' && <MokaIntegration />}</Page.Column>
      </Page.TwoColumn>
      {/* <div
        className={`
          grid grid-cols-1 gap-4
          @md:grid-cols-2
          @lg:grid-cols-3
        `}
      >
        <CardSummary
          label='Jumlah Produk'
          value='100'
          description='Produk terdaftar di outlet ini'
        />
        <CardSummary
          label='Jumlah Karyawan'
          value='120'
          description='Karyawan aktif di outlet ini'
        />
        <CardSummary
          label='Perangkat POS'
          value='2'
          description='Perangkat transaksi yang digunakan'
        />
      </div> */}
    </Page>
  )
}

function useOutlet() {
  const { data: outlet } = useSuspenseQuery({
    ...outletMasterApi.detail.query({ params: { id: useAuth().outlet.oId } }),
    select: ({ data }) => data.outlet,
  })

  return outlet
}

function GeneralInfo() {
  const outlet = useOutlet()

  return (
    <CardMetadata
      title='Informasi Outlet'
      contents={{
        ID: outlet.id,
        Nama: outlet.name,
        Jenis: outlet.type,
        Email: outlet.email,
        'No. Telepon': outlet.phone,
        Alamat: outlet.address,
        Deskripsi: outlet.desc,
      }}
    />
  )
}

function MokaIntegration() {
  const outlet = useOutlet()
  const isConnected = !!outlet.mokaId

  const { data } = useQuery({
    ...mokaApi.detail.query({ params: { outletId: outlet.id } }),
    enabled: isConnected,
  })

  return (
    <Card>
      <Card.Header className='border-b'>
        <Card.Title>Integrasi Moka</Card.Title>
      </Card.Header>
      <Card.Content>
        {!isConnected && (
          <>
            <MokaConnectDialog.Root />
            <Button size='sm' variant='outline' onClick={() => MokaConnectDialog.upsert()}>
              <WorkflowIcon />
              Hubungkan Moka
            </Button>
          </>
        )}
        {data?.data && (
          <div className='flex flex-col gap-1'>
            <div>ID: {data.data.id}</div>
            <div>Outlet: {data.data.name}</div>
          </div>
        )}
      </Card.Content>
    </Card>
  )
}
